import React from 'react';
import { LoadingNav, LoadingCard, LoadingHeader } from './LoadingComponents';

const LoadingFlexView = ({ step }) => {
  const Cards = () => (
    <>
      <LoadingCard type="config-card" />
      <LoadingCard type="config-card" />
      <LoadingCard type="config-card" />
      <LoadingCard type="config-card" />
      <LoadingCard type="config-card" />
      <LoadingCard type="config-card" />
    </>
  );
  return (
    <>
      <LoadingNav />
      <LoadingHeader className="loading-header--config-view" />
      {step === 'packages' ? (
        <div className="flex-view__grid flex-view__packages-grid">
          <Cards />
        </div>
      ) : step === 'options' ? (
        <div className="flex-view__grid flex-view__options-grid">
          <Cards />
        </div>
      ) : (
        <div className="flex-view__grid gridview__grid-container">
          <Cards />
        </div>
      )}
    </>
  );
};

export default LoadingFlexView;
